import { PlantSchema } from "../services/volateq-api/api-schemas/plant-schema";

export class PlantStore {
  private _plant: PlantSchema | null = null;

  public set(plant: PlantSchema | null) {
    this._plant = plant;
  }

  public get currentPlant(): PlantSchema | null {
    return this._plant;
  }
}

export const plantStore = new PlantStore();